module.exports = __webpack_public_path__ + "img/kp_gif.edfc4917.gif";